import DocumentsView from "./documentsView"

export default DocumentsView
